<h3 *ngIf="label">
    {{ label | translate }} <span>{{isRequired ? '*' : ''}}</span>
    <mat-error *ngIf="isRequired && isErrorVisile" class="requiredError">
        <span>{{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}</span>
    </mat-error>
</h3>

<div [ngClass]="direction === 'column' ? 'attach-div-column' : 'attach-div-row'">
    <ng-container *ngIf="!disabled && !(files && files.length >= maxFiles)">
        <div *ngIf="!smallSize; else smallSizeContainer" class="container" appDnd (fileDropped)="onFileDropped($event)">
            <input type="file" #fileDropRef multiple (change)="fileBrowseHandler($event)" (click)="markAsTouched()" />
            <img src="assets/alden-extension/images/upload-file.svg">
            <h3>{{ 'ALDEN.FILES.DROP.DRAG' | translate }}</h3>
            <h3>{{ 'ALDEN.FILES.DROP.OR' | translate }}</h3>
            <label for="fileDropRef">{{ 'ALDEN.FILES.DROP.SEARCH' | translate}}</label>
        </div>

        <ng-template #smallSizeContainer>
            <div class="w100">
                <div class="container" appDnd (fileDropped)="onFileDropped($event)">
                    <input type="file" #fileDropRef [multiple]="!maxFiles || maxFiles > 1"
                        [accept]="mimeTypes.join(',')" (change)="fileBrowseHandler($event)" (click)="markAsTouched()" />
                    <div class="small-container">
                        <h3>{{ 'ALDEN.FILES.DROP.DRAG' | translate }} {{ 'ALDEN.FILES.DROP.OR' | translate }} {{
                            'ALDEN.FILES.DROP.CLICK_HERE' | translate }}</h3>
                        <img src="assets/alden-extension/images/upload-file.svg">
                    </div>
                </div>
                <mat-error *ngIf="!label && isRequired && isErrorVisile" class="requiredError">
                    <span>{{ 'ALDEN.VALIDATORS.ERRORS.REQUIRED' | translate }}</span>
                </mat-error>
            </div>
        </ng-template>
    </ng-container>

    <mat-accordion #accordion *ngIf="files && files.length > 0">
        <div *ngIf="group.controls[controlName].hasError('maxSize')" class="size-limit">
            <mat-icon class="custom-mat-icon">warning</mat-icon>
            <span>{{ 'ALDEN.MESSAGES.ERRORS.FILE_SIZE_LIMIT' | translate : { fileSizeLimit } }}</span>
        </div>
        <div class="accordion-div" *ngFor="let file of files; let i = index">
            <mat-expansion-panel #panel class="expansion-panel" [expanded]="i === files.length-1 && files.length === 1">
                <mat-expansion-panel-header>
                    <mat-panel-title *ngIf="!panel.expanded || !editableFields?.includes('name'); else editableName">
                        {{file.name}} </mat-panel-title>
                    <ng-template #editableName>
                        <mat-panel-title (click)="$event.stopPropagation()">
                            <mat-form-field class="title-mat-form">
                                <mat-label>{{ 'ALDEN.FILES.FIELDS.NAME' |
                                    translate}}</mat-label>
                                <textarea matInput cdkTextareaAutosize [(ngModel)]="file.name"
                                    (ngModelChange)="changeName(i)" [disabled]="disabled" required
                                    (focus)="setCursorPosition($event, i)"></textarea>
                            </mat-form-field>
                        </mat-panel-title>
                    </ng-template>
                    <mat-panel-description>
                        <mat-icon>{{ (file.mimeType | mimeType).icon }}</mat-icon>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div>
                    <div>
                        <div>
                            <p *ngIf="file.title && !editableFields?.includes('title')"><b>{{ 'ALDEN.FILES.FIELDS.TITLE'
                                    | translate}}: </b>{{ file.title }}</p>
                            <p *ngIf="file.description && !editableFields?.includes('description')"><b>{{
                                    'ALDEN.FILES.FIELDS.DESCRIPTION' | translate}}: </b>{{ file.description }}</p>
                            <p><b>{{ 'ALDEN.FILES.FIELDS.MIME_TYPE' | translate}}: </b>
                                {{ (file.mimeType | mimeType).description }}</p>
                            <p><b>{{ 'ALDEN.FILES.FIELDS.SIZE' | translate}}: </b>
                                {{ file.size | size }}</p>
                            <p><b>{{ 'ALDEN.FILES.FIELDS.LAST_MODIFICATION_DATE' | translate}}: </b>
                                {{ file.lastModDate | date : defaultDateTimeFormat }}
                            </p>
                            <p *ngIf="file.versionLabel as versionLabel"><b>{{ 'ALDEN.FILES.FIELDS.VERSION_LABEL' |
                                    translate}}: </b>{{ versionLabel }}</p>
                        </div>
                        <div *ngIf="editableFields?.includes('title')">
                            <mat-form-field class="w100">
                                <mat-label>{{ 'ALDEN.FILES.FIELDS.TITLE' |
                                    translate}}</mat-label>
                                <textarea matInput cdkTextareaAutosize [(ngModel)]="file.title"
                                    (ngModelChange)="sendData()" [disabled]="disabled"
                                    [required]="mandatoryFields?.includes('title')"></textarea>
                            </mat-form-field>
                        </div>
                        <div *ngIf="editableFields?.includes('description')">
                            <mat-form-field class="w100">
                                <mat-label>{{ 'ALDEN.FILES.FIELDS.DESCRIPTION' |
                                    translate}}</mat-label>
                                <textarea matInput cdkTextareaAutosize [(ngModel)]="file.description"
                                    (ngModelChange)="sendData()" [disabled]="disabled"
                                    [required]="mandatoryFields?.includes('title')"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="action-buttons">
                        <button *ngIf="file.uuid" mat-raised-button color="primary"
                            (click)="aldenService.viewNode(file.uuid)"
                            [matTooltip]="'ALDEN.FILES.VIEW_ITEM' | translate">
                            <mat-icon style="color: white">visibility</mat-icon> {{ 'APP.ACTIONS.VIEW' | translate }}
                        </button>
                        <button *ngIf="!disabled" mat-raised-button color="warn" (click)="deleteFile(i)"
                            [matTooltip]="'ALDEN.FILES.DELETE_ITEM' | translate">
                            <mat-icon style="color: white">delete</mat-icon> {{ 'APP.ACTIONS.DELETE' | translate }}
                        </button>
                        <button *ngIf="disabled && downloadEnabled" mat-raised-button color="primary" (click)="downloadFile(file.uuid)"
                            [matTooltip]="'ALDEN.FILES.DOWNLOAD_ITEM.TOOLTIP' | translate">
                            <mat-icon style="color: white">cloud_download</mat-icon> {{ 'ALDEN.FILES.DOWNLOAD_ITEM.TITLE' | translate }}
                        </button>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-accordion>

    <mat-card *ngIf="((!maxFiles || maxFiles > 1) && (!files || files.length == 0)) || (disabled && files?.length == 0)"
        class="center">
        <mat-card-content>
            {{ 'ALDEN.FILES.EMPTY_ITEM' | translate }}
        </mat-card-content>
    </mat-card>
</div>